import { string, object } from 'yup';

const schema = object().shape({
  password: string().required('The Password is required'),
  passwordConfirmation: string().required('The Password Confirmation is required'),
});

export default schema;
